import styled, { css } from "styled-components";
import { darken } from "polished";
import { borderRadius, color, onHover, textOverflow, typeStyle, units, visuallyHidden } from "@m/alchemy-theme";
import { Button } from "../../button/Button";
import * as SelectStyled from "../select/Select.styled";
import { Pill } from "../../pill/Pill";
import { CloseButton } from "../../close-button/CloseButton";
export const Wrapper = styled.div `
  max-width: 100%;
  select {
    ${visuallyHidden()};
  }
  ${({ isFullWidth }) => (isFullWidth ? "" : "display: inline-block;")}
  ${({ isInline, isFullWidth }) => isInline
    ? css `
          display: ${isFullWidth ? "flex" : "inline-flex"};
        `
    : ""}
`;
export const MenuTitleOption = styled(SelectStyled.Item).attrs({ as: "h2", isSelectable: false }) `
  background-color: ${color("container", { palette: "structural", colorScheme: "alchemyPanel" })};
  font-weight: bold;
  cursor: revert;
  border-bottom: 1px solid ${color("lineContrast")};
  padding-right: ${units(4)};

  // instead of :first-child or :first-of-type on generic Item, always mark this as having rounded corners
  border-radius: ${borderRadius("extraLarge")} ${borderRadius("extraLarge")} 0 0;

  &:empty::after {
    // quick fix for collapsing with empty title text
    content: " ";
    white-space: pre;
  }
`;
export const MenuTitleCloseButton = styled(CloseButton) `
  position: absolute;
  z-index: 1;
  top: 5px;
  right: ${units(1.25)};
`;
export const SelectedMultiOption = styled(Pill) `
  margin-right: ${units(0.5)};
  margin-bottom: ${units(1)};
  padding: 7px ${({ disabled }) => (disabled ? units(1.5) : units(3.5))} 7px ${units(1.5)};
  background-color: ${color("highlight")};
  border-radius: ${borderRadius("extraLarge")};
  line-height: 1;
  ${textOverflow()};

  ${({ isOptionValid }) => !isOptionValid &&
    css `
      border: 1px solid ${color("base", { palette: "interactiveDestructive" })};
    `}

  button {
    border-radius: 50%;
    color: ${(props) => darken(0.025, color("base")(props))};
    display: ${({ disabled }) => (disabled ? "none" : "flex")};
    align-items: center;
    margin: 0 2px 0 0;
    position: absolute;
    width: 24px;
    padding: 0;
    right: 0;
    height: 24px;
    top: 50%;
    transform: translateY(-50%);

    svg {
      stroke: currentColor;
      stroke-width: 1;
      margin-right: 0px;
    }

    ${onHover(css `
      color: ${color("contrast")};
    `)}

    [data-whatintent="keyboard"] &:focus {
      box-shadow: 0 0 0 2px inset hsla(220, 100%, 50%, 80%);
    }

    &:focus {
      /* high contrast mode */
      outline: 2px solid transparent;
      outline-offset: -2px;
    }
  }
`;
export const Toggle = styled(Button) `
  && {
    min-height: ${units(3.5)};
    min-width: ${units(4.5)};
    padding: ${units(0.75)} ${units(1.5)};
    ${SelectedMultiOption} + & {
      margin-left: ${units(0.5)};
    }
  }

  ${({ isOpen, ...props }) => isOpen
    ? css `
          background-color: ${color("hint")(props)};
          border-color: ${color("highlight")(props)};
        `
    : ""};
`;
export const Plus = styled.div `
  display: inline-block;
`;
export const SelectedMultiOptionPrefix = styled.span `
  color: ${color("typeMeta")};
  padding-right: ${units(0.75)};
  ${typeStyle("captionS")};
  vertical-align: text-bottom;
`;
export const ToggleOptionWrapper = styled.div `
  ${({ isFullWidth }) => isFullWidth &&
    css `
      min-height: 30px;
      padding-right: ${units(5)};
    `};

  margin-bottom: ${({ hasValues }) => (hasValues ? units(-1) : "")};
  position: relative;
  width: 100%;

  ${({ isInline }) => isInline
    ? css `
          max-width: 100%;
          display: inline-flex;
          margin-bottom: 0;
        `
    : css `
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
        `}
`;
export const AriaUpdateContainer = styled.output `
  ${visuallyHidden()}
`;
